import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

import { qrCodeButtonsData } from "../../../conts/QrCodeButtonData";
import { fonts, themeColor } from "../../../ui/theme";
import { pixelTrackEvent } from "../../../utils/facebookPixel";
import { Container } from "./../../../ui/base/Container/Container";
import { QrCodeButton } from "./../../../ui/base/QrCodeButton/QrCodeButton";
import { QrCodeButtonStyled } from "./../../../ui/base/QrCodeButton/QrCodeButtonStyled";

export const DownloadSection = () => {
  const sectionRef = useRef();
  const location = useLocation();

  useEffect(() => {
    location.hash === "#download" &&
      sectionRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
  }, [location]);

  return (
    <DownloadWrapper ref={sectionRef} id="#download">
      <Container>
        <Title>Download the App</Title>
        <ButtonRow>
          {qrCodeButtonsData?.map((item) => (
            <QrCodeButton
              key={item.text}
              qrcode={item.qrcode}
              href={item.href}
              target="_blank"
              icon={item.icon}
              bg="blue"
              color="white"
              onClick={() => pixelTrackEvent(`Home: Clicked on ${item.text}`)}
            >
              {item.text}
            </QrCodeButton>
          ))}
        </ButtonRow>
      </Container>
    </DownloadWrapper>
  );
};

const Title = styled.div`
  font-size: ${fonts.sizes["h3.6"]};
  font-weight: 600;
  text-align: center;
  color: ${themeColor("basicBlack")};
  letter-spacing: -0.01em;
  margin-bottom: 30px;
  margin-top: 10px;
  padding-top: 50px;

  @media (max-width: 600px) {
    font-size: 28px;
  }
`;

export const DownloadWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media (max-width: 600px) {
    gap: 24px;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  padding-bottom: 50px;

  ${QrCodeButtonStyled} {
    background: #1d1d1f;
    border-radius: 100px;
    height: 60px;
    padding: 14px 28px;
    width: auto;
    min-width: 180px;
    font-weight: 500;
    font-size: 16px;
    transition:
      background 0.2s ease,
      transform 0.15s ease;

    &:hover {
      background: ${themeColor("blue")};
      overflow: visible;
      border-radius: 0 0 10px 10px;
      box-shadow: 0 0 20px 0 rgba(25, 29, 58, 0.17);
      & > div {
        opacity: 100;
        grid-template-rows: 1fr;
      }
    }

    svg {
      width: 22px;
      min-width: 22px;
      margin-right: 10px;
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;

    ${QrCodeButtonStyled} {
      width: 100%;
      max-width: 280px;
      justify-content: center;
    }
  }
`;
